export default __webpack_public_path__ + "static/media/Signin.3eaf81b0.jpg";